import React from 'react';
import { X } from 'lucide-react';

/**
 * StickyFilterChips — horizontally-scrollable strip of active filter pills
 * that sticks to the top on mobile. Tap a chip to clear that filter.
 *
 * chips: [{ key, label, onClear }]
 * onClearAll: optional callback to wipe every filter
 */
export default function StickyFilterChips({ chips = [], onClearAll }) {
  const visible = chips.filter(c => c && c.label);
  if (visible.length === 0) return null;
  return (
    <div className="sticky top-14 z-30 -mx-4 md:hidden bg-white/95 backdrop-blur-xl border-b border-neutral-200" data-testid="mobile-sticky-filter-chips">
      <div className="flex items-center gap-2 px-4 py-2 overflow-x-auto no-scrollbar">
        {visible.map((c) => (
          <button
            key={c.key}
            onClick={c.onClear}
            className="shrink-0 inline-flex items-center gap-1 pl-3 pr-2 py-1 rounded-full bg-fuchsia-50 border border-fuchsia-200 text-fuchsia-800 text-xs font-medium hover:bg-fuchsia-100 active:scale-95 transition"
            data-testid={`chip-${c.key}`}
          >
            <span className="truncate max-w-[140px]">{c.label}</span>
            <X className="w-3 h-3 opacity-60" />
          </button>
        ))}
        {onClearAll && (
          <button
            onClick={onClearAll}
            className="shrink-0 text-xs text-neutral-500 hover:text-neutral-800 underline underline-offset-2"
          >
            Clear all
          </button>
        )}
      </div>
    </div>
  );
}
